import { type SVGProps } from 'react'

export function GradingMethodIconRubric(props: SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height={30} viewBox="0 0 30 30" width={30} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10.6667 1.13333C5.40155 1.13333 1.13333 5.40155 1.13333 10.6667V19.3333C1.13333 24.5984 5.40155 28.8667 10.6667 28.8667H19.3333C24.5984 28.8667 28.8667 24.5984 28.8667 19.3333V10.6667C28.8667 5.40155 24.5984 1.13333 19.3333 1.13333H10.6667Z"
        fill="#7A5AF8"
      />
      <path
        d="M10.6667 1.13333C5.40155 1.13333 1.13333 5.40155 1.13333 10.6667V19.3333C1.13333 24.5984 5.40155 28.8667 10.6667 28.8667H19.3333C24.5984 28.8667 28.8667 24.5984 28.8667 19.3333V10.6667C28.8667 5.40155 24.5984 1.13333 19.3333 1.13333H10.6667Z"
        stroke="#F4F3FF"
        strokeWidth={1.73333}
      />
      <path
        d="M17.4074 10.1842C17.9671 10.1842 18.247 10.1842 18.4766 10.2457C19.0997 10.4126 19.5863 10.8993 19.7533 11.5224C19.8148 11.752 19.8148 12.0319 19.8148 12.5916V18.1286C19.8148 19.1398 19.8148 19.6454 19.618 20.0317C19.4449 20.3714 19.1687 20.6476 18.829 20.8207C18.4427 21.0175 17.9371 21.0175 16.9259 21.0175H13.0741C12.0629 21.0175 11.5573 21.0175 11.171 20.8207C10.8313 20.6476 10.5551 20.3714 10.382 20.0317C10.1852 19.6454 10.1852 19.1398 10.1852 18.1286V12.5916C10.1852 12.0319 10.1852 11.752 10.2467 11.5224C10.4137 10.8993 10.9003 10.4126 11.5234 10.2457C11.753 10.1842 12.0329 10.1842 12.5926 10.1842M13.1944 16.8045L14.3981 18.0082L17.1065 15.2999M13.5556 11.3879H16.4444C16.7815 11.3879 16.95 11.3879 17.0788 11.3223C17.192 11.2646 17.2841 11.1725 17.3418 11.0593C17.4074 10.9305 17.4074 10.762 17.4074 10.4249V9.94343C17.4074 9.60636 17.4074 9.43783 17.3418 9.30909C17.2841 9.19584 17.192 9.10377 17.0788 9.04607C16.95 8.98047 16.7815 8.98047 16.4444 8.98047H13.5556C13.2185 8.98047 13.0499 8.98047 12.9212 9.04607C12.808 9.10377 12.7159 9.19584 12.6582 9.30909C12.5926 9.43783 12.5926 9.60636 12.5926 9.94343V10.4249C12.5926 10.762 12.5926 10.9305 12.6582 11.0593C12.7159 11.1725 12.808 11.2646 12.9212 11.3223C13.0499 11.3879 13.2185 11.3879 13.5556 11.3879Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.2037}
      />
    </svg>
  )
}

export function GradingMethodIconPassFail(props: SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height={30} viewBox="0 0 30 30" width={30} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10.6667 1.13333C5.40155 1.13333 1.13333 5.40155 1.13333 10.6667V19.3333C1.13333 24.5984 5.40155 28.8667 10.6667 28.8667H19.3333C24.5984 28.8667 28.8667 24.5984 28.8667 19.3333V10.6667C28.8667 5.40155 24.5984 1.13333 19.3333 1.13333H10.6667Z"
        fill="#66C61C"
      />
      <path
        d="M10.6667 1.13333C5.40155 1.13333 1.13333 5.40155 1.13333 10.6667V19.3333C1.13333 24.5984 5.40155 28.8667 10.6667 28.8667H19.3333C24.5984 28.8667 28.8667 24.5984 28.8667 19.3333V10.6667C28.8667 5.40155 24.5984 1.13333 19.3333 1.13333H10.6667Z"
        stroke="#E4FBCC"
        strokeWidth={1.73333}
      />
      <path
        d="M11.9907 16.8589V21.0175L14.8212 19.8853C14.8872 19.8589 14.9202 19.8457 14.9543 19.8405C14.9846 19.8358 15.0154 19.8358 15.0456 19.8405C15.0797 19.8457 15.1127 19.8589 15.1788 19.8853L18.0092 21.0175V16.8589M19.5139 13.4944C19.5139 15.9873 17.4929 18.0082 15 18.0082C12.507 18.0082 10.4861 15.9873 10.4861 13.4944C10.4861 11.0014 12.507 8.98047 15 8.98047C17.4929 8.98047 19.5139 11.0014 19.5139 13.4944Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.2037}
      />
    </svg>
  )
}

export function GradingMethodIconManual(props: SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height={30} viewBox="0 0 30 30" width={30} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10.6667 1.13333C5.40155 1.13333 1.13333 5.40155 1.13333 10.6667V19.3333C1.13333 24.5984 5.40155 28.8667 10.6667 28.8667H19.3333C24.5984 28.8667 28.8667 24.5984 28.8667 19.3333V10.6667C28.8667 5.40155 24.5984 1.13333 19.3333 1.13333H10.6667Z"
        fill="#47CD89"
      />
      <path
        d="M10.6667 1.13333C5.40155 1.13333 1.13333 5.40155 1.13333 10.6667V19.3333C1.13333 24.5984 5.40155 28.8667 10.6667 28.8667H19.3333C24.5984 28.8667 28.8667 24.5984 28.8667 19.3333V10.6667C28.8667 5.40155 24.5984 1.13333 19.3333 1.13333H10.6667Z"
        stroke="#ECFDF3"
        strokeWidth={1.73333}
      />
      <path
        d="M11.9306 14.6646V16.3364M11.9306 14.6646V10.6523C11.9306 10.0983 12.3887 9.64919 12.9537 9.64919C13.5188 9.64919 13.9769 10.0983 13.9769 10.6523M11.9306 14.6646C11.9306 14.1106 11.4725 13.6615 10.9074 13.6615C10.3424 13.6615 9.88428 14.1106 9.88428 14.6646V16.0021C9.88428 18.772 12.1747 21.0175 15 21.0175C17.8254 21.0175 20.1158 18.772 20.1158 16.0021V12.6585C20.1158 12.1045 19.6577 11.6554 19.0926 11.6554C18.5275 11.6554 18.0695 12.1045 18.0695 12.6585M13.9769 10.6523V14.3303M13.9769 10.6523V9.98356C13.9769 9.42957 14.4349 8.98047 15 8.98047C15.5651 8.98047 16.0232 9.42957 16.0232 9.98356V10.6523M16.0232 10.6523V14.3303M16.0232 10.6523C16.0232 10.0983 16.4812 9.64919 17.0463 9.64919C17.6114 9.64919 18.0695 10.0983 18.0695 10.6523V12.6585M18.0695 12.6585V14.3303"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.2037}
      />
    </svg>
  )
}

export function GradingMethodIconStandardsBased(props: SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="30" viewBox="0 0 30 30" width="30" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M19.333 1.13379C24.5981 1.13379 28.8662 5.40188 28.8662 10.667V19.333C28.8662 24.5981 24.5981 28.8662 19.333 28.8662H10.667C5.40188 28.8662 1.13379 24.5981 1.13379 19.333V10.667C1.13379 5.40188 5.40188 1.13379 10.667 1.13379H19.333Z"
        fill="#FF9C66"
      />
      <path
        d="M19.333 1.13379C24.5981 1.13379 28.8662 5.40188 28.8662 10.667V19.333C28.8662 24.5981 24.5981 28.8662 19.333 28.8662H10.667C5.40188 28.8662 1.13379 24.5981 1.13379 19.333V10.667C1.13379 5.40188 5.40188 1.13379 10.667 1.13379H19.333Z"
        stroke="#FFE6D5"
        strokeWidth="1.73333"
      />
      <path
        d="M16.504 11.088L17.4068 11.9908M14.6984 12.8936L15.6012 13.7963M12.8929 14.6991L13.7957 15.6019M11.0873 16.5047L11.9901 17.4075M9.32128 18.3498L11.6496 20.6781C11.7688 20.7973 11.8284 20.8569 11.8971 20.8792C11.9575 20.8989 12.0226 20.8989 12.0831 20.8792C12.1518 20.8569 12.2114 20.7973 12.3305 20.6781L20.6774 12.3313C20.7966 12.2121 20.8562 12.1525 20.8785 12.0838C20.8981 12.0234 20.8981 11.9583 20.8785 11.8978C20.8562 11.8291 20.7966 11.7695 20.6774 11.6504L18.3491 9.32201C18.2299 9.20284 18.1703 9.14325 18.1016 9.12093C18.0412 9.10129 17.976 9.10129 17.9156 9.12093C17.8469 9.14325 17.7873 9.20284 17.6681 9.32201L9.32128 17.6689C9.20211 17.788 9.14252 17.8476 9.1202 17.9163C9.10056 17.9768 9.10056 18.0419 9.1202 18.1023C9.14252 18.171 9.20211 18.2306 9.32128 18.3498Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2037"
      />
    </svg>
  )
}
